import debounce from "debounce";
class PageHero {
    constructor() {
        this.pageHeroVideos = document.querySelectorAll(".pageHero__video");
        // Assume source video is 640x180
        this.defaultWidth = 640;
        this.defaultHeight = 360;
        this.init();
    }

    init() {
        const self = this;

        window.onresize = debounce(function() {
            self.setVideoSize();
        }, 200);
        this.setVideoSize();

        window.onscroll = debounce(function() {
            self.setVideoPlayStatus();
        }, 500);
        this.setVideoPlayStatus();
    }

    setVideoSize() {
        // Size the video to fill the hero area
        const self = this;
        this.pageHeroVideos.forEach(function(videoItem) {
            let parentNode = videoItem.parentNode;
            let parentW = parentNode.getBoundingClientRect().width;
            let parentH = parentNode.getBoundingClientRect().height;

            let scale_w = parentW / self.defaultWidth;
            let scale_h = parentH / self.defaultHeight;
            let scale = scale_w > scale_h ? scale_w : scale_h;
            videoItem.style.height = scale * self.defaultHeight + "px";
            videoItem.style.width = scale * self.defaultWidth + "px";
        });
    }

    setVideoPlayStatus() {
        // Pause the video when out of view
        this.pageHeroVideos.forEach(function(videoItem) {
            let parentNode = videoItem.parentNode;
            let parentNodeBottom = parentNode.getBoundingClientRect().bottom;

            if (parentNodeBottom < 0) {
                videoItem.pause();
            } else {
                videoItem.play();
            }
        });
    }
}

export default PageHero;
